import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RoutesPath } from '@shared/routes-path';
import { DefaultComponent } from './layouts/default/default.component';
import { DefaultModule } from './layouts/default/default.module';

const routes: Routes = [
  {
    // default layout must be first because WelcomePage has url -> '' (empty)
    path: '',
    loadChildren: () =>
      import('./layouts/default/default-routing.module').then((mod) => mod.DefaultRoutingModule),
  },
  {
    // notFound page must be last item in all routes
    path: RoutesPath.notFound,
    component: DefaultComponent, // but it uses default layout
    loadChildren: () =>
      import('./layouts/default/pages/page-not-found/page-not-found.module').then(
        (mod) => mod.PageNotFoundModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
    }),
    DefaultModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
